import LocationsService from "../services/locations/locationDetails.service"
import { GetAllLocationDetailsInterface } from "@type/locations.types"
import { useState } from "react"

const useLocations = () => {
	const [allLocations, setAllLocations] = useState<GetAllLocationDetailsInterface[]>([])
	const [isAllLocationsLoading, setIsAllLocationsLoading] = useState(false)

	const fetchAllLocationsDetails = async () => {
		try {
			setIsAllLocationsLoading(true)
			const { data: locationResponse } = await LocationsService.getAllLocationsDetail()
			setAllLocations(locationResponse)
			setIsAllLocationsLoading(false)
		} catch {
			setIsAllLocationsLoading(false)
		}
	}

	return {
		allLocations,
		fetchAllLocationsDetails,
		isAllLocationsLoading,
	}
}

export default useLocations
